<template>
  <footer class="site-footer">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <p>https://forms.gle/G2BNiMHne83q8geu7</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  components: {},

  data() {
    return {
      dropDowns: {
        profile: false,
        notifications: false,
      },
    };
  },
  mounted: function() {},
  methods: {},
};
</script>
